import { Columns } from 'components/elements'
import React, { Component } from 'react'
import './insuranceFeatures.sass'
import './insuranceFeaturesMobile.css'

class InsuranceFeatures extends Component {
  render() {
    return (
      <div className="insurnace-feature-wrap has-background-white-ter mt-4">
        <div className="container medium">
          <Columns className="insurance-features-header is-centered">
            <Columns.Column size={8}>
              <h2 className="has-text-weight-bold">We've got your back</h2>
              <p>Accidents can happen, so we’re covering you.</p>
            </Columns.Column>
          </Columns>
          <Columns className="is-vcentered insurance-features-blocks">
            <Columns.Column size={4}>
              <div className="insurance-panel">
                <img
                  className="ins-icon"
                  src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1587589497/frontend_assets/homepage-images/insurance-features/theif.jpg"
                  alt="Theft and Damage Protection"
                  width="112px"
                  height="112px"
                />
                <h3 className="title is-size-5 has-text-weight-bold mt-4">
                  Damage and Protection
                </h3>
                <p className="is-size-5">
                  Up to $40K of damage <br />
                  and theft coverage.
                </p>
              </div>
            </Columns.Column>
            <Columns.Column size={4}>
              <div className="insurance-panel feature-panel">
                <img
                  className="ins-icon"
                  src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1587589497/frontend_assets/homepage-images/insurance-features/money.jpg"
                  alt="$1million dollars coverage"
                  width="112px"
                  height="112px"
                />
                <h3 className="title is-size-5 has-text-weight-bold mt-4">
                  $1,000,000
                </h3>
                <p className="is-size-5">
                  Up to <strong>$1M</strong> of <br />
                  liability insurance.
                </p>
              </div>
            </Columns.Column>
            <Columns.Column size={4}>
              <div className="insurance-panel">
                <img
                  className="ins-icon"
                  src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1587589897/frontend_assets/homepage-images/insurance-features/resolution.jpg"
                  alt="Resolution Support"
                  width="112px"
                  height="112px"
                />
                <h3 className="title is-size-5 has-text-weight-bold mt-4">
                  Resolution Support
                </h3>
                <p className="is-size-5">
                  Whatever happens,
                  <br />
                  we’re here.
                </p>
              </div>
            </Columns.Column>
          </Columns>
          <Columns className="insurance-features-footer">
            <Columns.Column>
              <a href="/how-it-works/insurance">
                Learn More About Our Daily Insurance
              </a>
            </Columns.Column>
          </Columns>
        </div>
      </div>
    )
  }
}

export default InsuranceFeatures
